import { CHANNEL, DISCORD } from "icons";
import IntegrationSidebarLayout from "../components/sidebar-layout";
import IntegrationIconHeader from "../components/icon-header";

// /integrations/discord/*: Discord logo header + Channels tab.
export default function DiscordIntegrationLayout() {
  return (
    <IntegrationSidebarLayout
      name="integrations-discord"
      header={<IntegrationIconHeader icon={DISCORD} title="Discord" />}
      items={[{ title: "Channels", icon: CHANNEL, url: "/integrations/discord" }]}
    />
  );
}
